import { useEffect, useState } from 'react';
import { isDisplayableImageUrl } from '../utils/assignmentSubmission';
import { preferSameOriginSchoolMediaUrl } from '../utils/schoolMediaUrl';
import { resolveMediaDisplayUrl } from '../utils/tenantMediaUpload';

export function useMediaDisplayUrl(
  mediaId: string | null | undefined,
  fallbackUrl?: string | null,
  /** Super-admin: scope lookup to a tenant (`x-tenant-id`). */
  tenantId?: string | number
): string {
  const fallback = preferSameOriginSchoolMediaUrl((fallbackUrl ?? '').trim());
  const [url, setUrl] = useState(() => {
    if (fallback && isDisplayableImageUrl(fallback)) return fallback;
    return '';
  });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const id = (mediaId ?? '').trim();
      // Prefer a fresh signed URL from media_id when present (logo_url can be a stale signed URL).
      if (id) {
        const resolved = await resolveMediaDisplayUrl(mediaId, fallback, tenantId);
        if (!cancelled) {
          setUrl(preferSameOriginSchoolMediaUrl(resolved) || resolved);
        }
        return;
      }
      if (fallback && isDisplayableImageUrl(fallback)) {
        setUrl(fallback);
        return;
      }
      if (!cancelled) setUrl('');
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [mediaId, fallback, tenantId]);

  return url;
}
